import produce from 'immer';
import create from 'zustand';

const useEditorStore = create(set => ({
  wire: {
    id: null,
    profile: null,
    disclaimer: null,
  },
  currentProfile: {},
  mediaTypes: [],
  cta: {},
  presetCTA: { companyCta: [], contributorCta: [] },
  set: fn => set(produce(fn)),
}));

export default useEditorStore;
